import {
  pgTable,
  text,
  serial,
  timestamp,
} from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const usersTable = pgTable("users", {
  id: serial("id").primaryKey(),
  name: text("name").notNull(),
  email: text("email").notNull().unique(),
  passwordHash: text("password_hash").notNull(),
  phone: text("phone"),
  role: text("role", { enum: ["admin", "broker", "investor"] }).notNull().default("investor"),
  membership: text("membership", { enum: ["free", "vip", "elite"] }).notNull().default("free"),
  status: text("status", { enum: ["pending", "approved", "rejected"] }).notNull().default("approved"),
  paymentStatus: text("payment_status", { enum: ["unpaid", "pending", "paid", "failed"] }).notNull().default("unpaid"),
  stripeCustomerId: text("stripe_customer_id"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
});

export const insertUserSchema = createInsertSchema(usersTable).omit({ id: true, createdAt: true });
export type InsertUser = z.infer<typeof insertUserSchema>;
export type User = typeof usersTable.$inferSelect;
